import useTwitchRequest from '@hooks/useTwitchRequest.js';
import { useCallback, useState } from 'preact/hooks';

export default function useTwitchWebhooks({
  twitchAccessToken,
  twitchBroadcasterID,
  twitchUsername,
  tokenValidated,
}) {
  const [twitchWebhooks, setTwitchWebhooks] = useState(null);
  const request = useTwitchRequest({
    twitchAccessToken,
    tokenValidated,
  });

  const getWebhooks = useCallback(() => {
    if (
      !twitchAccessToken ||
      twitchAccessToken.length === 0 ||
      !twitchBroadcasterID ||
      twitchBroadcasterID.length === 0 ||
      !twitchUsername ||
      twitchUsername.length === 0 ||
      !tokenValidated
    )
      return Promise.resolve(null);

    // UDP: '/webhooks/twitch/manage/get'
    return request('/getWebhooks', {
      twitchUserID: twitchBroadcasterID,
      twitchUsername,
    }).then((result) => {
      if (result && result.success === true) {
        setTwitchWebhooks(result.data);
        return result.data;
      }

      return null;
    });
  }, [
    request,
    tokenValidated,
    twitchAccessToken,
    twitchBroadcasterID,
    twitchUsername,
  ]);

  const createWebhooks = useCallback(() => {
    // UDP: '/webhooks/twitch/manage/create'
    return request('/createWebhooks', {
      twitchUserID: twitchBroadcasterID,
      twitchUsername,
    }).then((result) => {
      if (result && result.success === true) {
        setTwitchWebhooks(result.data);
        return result.data;
      }

      return null;
    });
  }, [request, twitchBroadcasterID, twitchUsername]);

  const deleteWebhooks = useCallback(() => {
    // UDP: '/webhooks/twitch/manage/delete'
    return request('/deleteWebhooks', {
      twitchUserID: twitchBroadcasterID,
      twitchUsername,
    }).then((result) => {
      if (result && result.success === true) {
        setTwitchWebhooks(result.data);
        return result.data;
      }

      return null;
    });
  }, [request, twitchBroadcasterID, twitchUsername]);

  return { getWebhooks, twitchWebhooks, createWebhooks, deleteWebhooks };
}
